"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HUBSPOT_FEATURES = exports.TIERS = exports.SUPPORT_LANGUAGES = exports.KEYWORDS = exports.APP_INTEGRATIONS = exports.CATEGORY_FEATURES = exports.CATEGORY = void 0;
var CATEGORY = 'CATEGORY';
exports.CATEGORY = CATEGORY;
var CATEGORY_FEATURES = 'CATEGORY_FEATURES';
exports.CATEGORY_FEATURES = CATEGORY_FEATURES;
var APP_INTEGRATIONS = 'APP_INTEGRATIONS';
exports.APP_INTEGRATIONS = APP_INTEGRATIONS;
var KEYWORDS = 'KEYWORDS';
exports.KEYWORDS = KEYWORDS;
var SUPPORT_LANGUAGES = 'SUPPORT_LANGUAGES';
exports.SUPPORT_LANGUAGES = SUPPORT_LANGUAGES;
var TIERS = 'TIERS';
exports.TIERS = TIERS;
var HUBSPOT_FEATURES = 'HUBSPOT_FEATURES';
exports.HUBSPOT_FEATURES = HUBSPOT_FEATURES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/Group.js
// module id = 256
// module chunks = 209 210 211 212